import React from 'react';
import { TradeOffer } from 'types/interfaces/tradeOffer';
import OfferSummaryCard from '../OfferSummaryCard';

// A canned, clearly-labeled example rendered through the REAL offer card
// component, so the sample teaches exactly what a live offer will look like.
// Art uses stable CDN scryfallIds (never api.scryfall.com).
const SAMPLE_OFFER: TradeOffer = {
  id: 'sample-offer',
  status: 'pending',
  proposer: {
    id: 0,
    username: 'Avid_Trader',
    isElite: true,
    avatarUrl: null,
    showAnimatedBorder: false,
    borderColor1: null,
    borderColor2: null,
    stats: { rating: 4.9, ratingCount: 41, cardsSent: 220 },
  },
  recipient: {
    id: -1,
    username: 'you',
    isElite: false,
    avatarUrl: null,
    showAnimatedBorder: false,
    borderColor1: null,
    borderColor2: null,
    stats: { rating: null, ratingCount: 0, cardsSent: 0 },
  },
  createdAt: '2026-07-01T00:00:00.000Z',
  expiresAt: '2026-07-08T00:00:00.000Z',
  respondedAt: null,
  failureReason: null,
  trades: null,
  totals: { proposerSendsPoints: 310, recipientSendsPoints: 135 },
  items: [
    {
      id: 1,
      direction: 'PROPOSER_SENDS',
      userMTGCardHaveId: null,
      quantity: 1,
      foil: false,
      condition: 'NEAR_MINT',
      lockedPricePoints: 310,
      lineTotalPoints: 310,
      card: {
        id: 507859,
        oracleId: null,
        scryfallId: '6580f4f9-870b-4258-8dce-48c606b90a6c',
        name: 'Lightning Bolt',
        setCode: 'pf25',
        setName: 'MagicFest 2025',
        collectorNumber: '13',
        lang: 'en',
        imageUrl: null,
      },
    },
    {
      id: 2,
      direction: 'RECIPIENT_SENDS',
      userMTGCardHaveId: null,
      quantity: 1,
      foil: false,
      condition: 'SLIGHTLY_PLAYED',
      lockedPricePoints: 135,
      lineTotalPoints: 135,
      card: {
        id: 24,
        oracleId: null,
        scryfallId: '00020b05-ecb9-4603-8cc1-8cfa7a14befc',
        name: 'Wildcall',
        setCode: 'ugin',
        setName: "Ugin's Fate",
        collectorNumber: '146',
        lang: 'en',
        imageUrl: null,
      },
    },
  ],
};

const SampleOfferCard: React.FC = () => (
  <section id="offers-sample" className="offers-zero-sample" aria-label="What an offer looks like">
    <h2 className="offers-zero-block-heading">What an offer looks like</h2>
    <div className="offers-zero-sample-card">
      <OfferSummaryCard offer={SAMPLE_OFFER} tab="received" isSample />
      <span className="offers-zero-sample-badge">Example</span>
    </div>
    <p className="offers-zero-sample-caption">
      Offers expire after 7 days. Prices lock the moment one is proposed and stay locked for the
      life of the trade.
    </p>
  </section>
);

export default SampleOfferCard;
